module.exports = __webpack_public_path__ + "static/media/black.5dd4a29d.png";